let pageStartTime = performance.now(); // time when script runs (early, ideally at page load)

document.addEventListener('lazybeforeunveil', e => {
  const img = e.target;

  img.addEventListener('load', () => {
    const firstLazyImageLoadTime = performance.now() - pageStartTime;
    console.log(`First lazy image (${img.dataset.src || img.src}) loaded after ${firstLazyImageLoadTime.toFixed(2)}ms`);
  }, { once: true }); // only once, for first image
}, { once: true }); // only once, for first lazy image unveil
